import { render, staticRenderFns } from "./KerstmisStart.vue?vue&type=template&id=0eb0356b&"
import script from "./KerstmisStart.vue?vue&type=script&lang=js&"
export * from "./KerstmisStart.vue?vue&type=script&lang=js&"
import style0 from "./KerstmisStart.vue?vue&type=style&index=0&id=0eb0356b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports